import { Text, TextType } from 'ui-components/components/text';
import { ConfirmDialogueModal } from '../../../../../../../components/modals/confirm-dialogue-modal';
import { messages } from './messages';

export const SetupConfigurationConfirmSaveDialogue = ({ onClose, onConfirm }) => {
  const onClickConfirm = () => {
    onConfirm();
    onClose();
  };
  return (
    <ConfirmDialogueModal
      body={<Text textType={TextType.Paragraph} value={messages.confirmChangePackageTypeBody} />}
      header={<Text textType={TextType.Paragraph} value={messages.confirmChangePackageTypeHeader} />}
      onClose={onClose}
      onConfirm={onClickConfirm}
    />
  );
};
